import { createEntityAdapter } from '@reduxjs/toolkit';

import type { ApiProduct } from '../../../../models/ecommerce/product/ApiProduct';

export const productsAdapter = createEntityAdapter<ApiProduct, string>({
    selectId: (product) => product.identifier,
});
